// extracted by mini-css-extract-plugin
export var maindiv = "educationTile-module--maindiv--868b4";
export var hoverOverMe = "educationTile-module--hoverOverMe--4wgSE";
export var imgDiv = "educationTile-module--imgDiv--tKT+T";
export var midImgDiv = "educationTile-module--midImgDiv--2PFuJ";
export var img = "educationTile-module--img--c5Rj6";
export var sideDiv = "educationTile-module--sideDiv--634N0";
export var sideOuterDiv = "educationTile-module--sideOuterDiv--0VvVs";
export var sideMidDiv = "educationTile-module--sideMidDiv--p5-sX";
export var degree = "educationTile-module--degree--GnWyT";
export var institute = "educationTile-module--institute--fcDBs";
export var year = "educationTile-module--year--sx0zL";
export var location = "educationTile-module--location--4q3YD";